<script setup>
</script>

<template>
  <!-- Si es una ruta nueva de imagen, usa etiqueta IMG -->
  <img v-if="confGlobal && confGlobal.value.LOGO_SVG_FULL && !confGlobal.value.LOGO_SVG_FULL.includes('<svg')" 
       :src="confGlobal.value.LOGO_SVG_FULL" 
       class="h-full w-auto object-contain" />
  <!-- Si sigue siendo el código viejo, usa v-html -->
  <div v-else-if="confGlobal && confGlobal.value.LOGO_SVG_FULL" v-html="confGlobal.value.LOGO_SVG_FULL" class="flex items-center h-full"></div>
</template>